<pp-advanced-filter-option-select
  data-testid="date-condition-select"
  class="advancedFilter__option"
  [ppItems]="advancedFilterDateOptions"
  [ppOption]="option"
  (ppOptionChange)="changeFieldCondition($event)"
  ppClass="advancedFilter__option--condition"
/>

<div class="advancedFilter__dateContainer">
  @if (
    option === EAdvancedFilterOptions.IS_BETWEEN ||
    option === EAdvancedFilterOptions.IS_BEFORE ||
    option === EAdvancedFilterOptions.IS_AFTER ||
    option === EAdvancedFilterOptions.IS_GREATER_THAN_OR_EQUAL ||
    option === EAdvancedFilterOptions.IS_LESS_THAN_OR_EQUAL ||
    option === EAdvancedFilterOptions.IS
  ) {
    <pp-datepicker
      data-testid="datepicker"
      [ppDate]="startDate"
      [class.advancedFilter__dateWide]="
        option === EAdvancedFilterOptions.IS_BEFORE ||
        option === EAdvancedFilterOptions.IS_AFTER ||
        option === EAdvancedFilterOptions.IS_GREATER_THAN_OR_EQUAL ||
        option === EAdvancedFilterOptions.IS_LESS_THAN_OR_EQUAL ||
        option === EAdvancedFilterOptions.IS
      "
      [ppMaxDate]="maxDate"
      (ppSelect)="changeFieldValue($event, 0)"
      [ppPlaceholder]="
        (option === EAdvancedFilterOptions.IS_BETWEEN ? 'from...' : 'select_date') | ppTranslate
      "
    />
  }

  @if (option === EAdvancedFilterOptions.IS_BETWEEN) {
    <pp-datepicker
      data-testid="datepicker"
      [ppDate]="endDate"
      (ppSelect)="changeFieldValue($event, 1)"
      [ppMaxDate]="maxDate"
      [ppPlaceholder]="'to...' | ppTranslate"
    />
  }
</div>
